import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=25374d9b&"
import script from "./Complaint.vue?vue&type=script&lang=js&"
export * from "./Complaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25374d9b')) {
      api.createRecord('25374d9b', component.options)
    } else {
      api.reload('25374d9b', component.options)
    }
    module.hot.accept("./Complaint.vue?vue&type=template&id=25374d9b&", function () {
      api.rerender('25374d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/leads/Edit/Complaint.vue"
export default component.exports